import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {EntityKey} from '../../entity/entity';
import {EntityBreak} from '../../entity/entity-break';
import {PersonLogin} from '../../person/person-login';
import {SelectionItem} from '../../selections/selection-item';
import {EntityBreakService} from '../../services/entity-break-service';
import {SelectionService} from '../../services/selection-service';
import {StringUtils} from '../../utils/string-utils';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'entity-break-dialog',
    templateUrl: './entity-break-dialog.component.html',
    styleUrls: ['./entity-break-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatIcon, FormsModule, MatProgressSpinner, MatDialogActions, CurrencyPipe]
})
export class EntityBreakDialogComponent {
  private readonly entityBreakService = inject(EntityBreakService);
  private readonly selectionService = inject(SelectionService);
  dialogRef = inject<MatDialogRef<EntityBreakDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  public entityKey: EntityKey;
  private personLogin: PersonLogin;
  readonly errorMessage = signal<string>(undefined!);
  readonly isBusy = signal<boolean>(undefined!);
  public selectedBreak!: EntityBreak;
  readonly entityBreaks = signal<EntityBreak[]>(undefined!);
  readonly updatesApplied = signal<boolean>(false);
  readonly factorCodes = signal<SelectionItem[]>(undefined!);

  constructor
  () {
    const data = this.data;

    this.entityKey = data.entityKey as EntityKey;
    this.personLogin = data.personLogin as PersonLogin;
    this.selectionService.getFactorCodes().subscribe(results => this.factorCodes.set(results), error => this.handleError(error));
    this.loadBreaks();
  }

  private loadBreaks(): void {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
    this.selectedBreak = null!;
    this.entityBreakService.getBreaks(this.entityKey).subscribe(results => {
      this.entityBreaks.set(results);
      this.isBusy.set(false);
    }, error => this.handleError(error));
  }

  public cancelUpdate(): void {
    this.selectedBreak = null!;
  }

  public selectBreak(entityBreak: EntityBreak) {
    this.selectedBreak = entityBreak;
  }

  public newBreak(): void {
    this.selectedBreak = new EntityBreak();
    this.selectedBreak.key = this.entityKey;
    this.selectedBreak.createUser = this.personLogin.person.userLogin;
    this.selectedBreak.createTimestamp = new Date();
  }

  public deleteBreak(entityBreak: EntityBreak): void {
    this.isBusy.set(true);
    this.entityBreakService.deleteBreak(entityBreak).subscribe(() => {
      this.updatesApplied.set(true);
      this.loadBreaks();
    }, error => this.handleError(error));
  }

  public saveBreak(): void {
    this.isBusy.set(true);
    this.entityBreakService.update(this.selectedBreak).subscribe(() => {
      this.updatesApplied.set(true);
      this.loadBreaks();
    }, error => this.handleError(error));
  }

  public close(): void {
    this.dialogRef.close(this.updatesApplied());
  }

  private handleError(error: HttpErrorResponse): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

}
